<div class="modal-header">
  <h5 class="modal-title">
    <ng-container *ngIf="!isEditing" i18n>Add</ng-container>
    <ng-container *ngIf="isEditing" i18n>Edit</ng-container>
    <ng-container i18n>Date Rule</ng-container>
    <small
      ><i
        matTooltip="Add conditions to automatically set a due date in relation to Arrival Date, Departure Date, or Invoice Date."
        matTooltipPosition="above"
        i18n-matTooltip
        class="fal info fa-question-circle"
      ></i
    ></small>
  </h5>
  <button (click)="onClose()" type="button" class="close">
    <span class="far fa-times"></span>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form" class="box box-mt-has-pd clearfix">
    <div class="row">
      <div class="col-sm-4">
        <mat-form-field2 class="mat-block">
          <input matInput type="number" placeholder="Days" i18n-placeholder formControlName="days" required />
          <mat-error *ngIf="form.get('operator').touched && form.get('operator').hasError('required')">
            <ng-container i18n>Value is required</ng-container>
          </mat-error>
          <mat-error *ngIf="form.get('days').touched && form.get('days').hasError('minNumber')">
            <ng-container i18n>Days need to be at least 1</ng-container>
          </mat-error>
        </mat-form-field2>
      </div>
      <div class="col-sm-4">
        <mat-form-field2 class="mat-block">
          <mat-select formControlName="operator" placeholder="Before / After" i18n-placeholder required>
            <mat-option value="before" i18n>Before</mat-option>
            <mat-option value="after" i18n>After</mat-option>
          </mat-select>
          <mat-error *ngIf="form.get('operator').touched && form.get('operator').hasError('required')">
            <ng-container i18n>Value is required</ng-container>
          </mat-error>
          <mat-error *ngIf="form.get('operator').touched && form.get('operator').hasError('afterInvoice')">
            <ng-container i18n>Due Date should not before Invoice Date</ng-container>
          </mat-error>
        </mat-form-field2>
      </div>
      <div class="col-sm-4">
        <mat-form-field2 class="mat-block">
          <mat-select formControlName="event" placeholder="Event" i18n-placeholder required>
            <mat-option value="arrival" i18n>Arrival Date</mat-option>
            <mat-option value="departure" i18n>Departure Date</mat-option>
            <mat-option value="invoice" i18n>Invoice Date</mat-option>
          </mat-select>
          <mat-error *ngIf="form.get('event').touched && form.get('event').hasError('required')">
            <ng-container i18n>Value is required</ng-container>
          </mat-error>
        </mat-form-field2>
      </div>
    </div>
    <div class="alert alert-secondary-info">
      <i class="fas fa-info-circle alert-icon"></i>
      <div class="alert-content" i18n>
        If after triggering this rule, due date is calculated to be before invoice date, it will set to one day after
        invoice date.
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button (click)="onClose()" type="button" [ngClass]="config.cancelBtnClass">
    <i class="far fa-times"></i> <ng-container i18n>cancel</ng-container>
  </button>
  <button *ngIf="isEditing" (click)="onClear()" type="button" [ngClass]="config.clearBtnClass">
    <i class="far fa-sync"></i> <ng-container i18n>Reset</ng-container>
  </button>
  <button (click)="onSave(form)" type="button" [ngClass]="config.doneBtnClass">
    <i [ngClass]="config.doneBtnIconClass"></i> <ng-container i18n>Save</ng-container>
  </button>
</div>
